import { Checkout, CheckoutStatus } from "@comparaonline/cicl-funnel-schema";
import { Router, MapRoutes } from "../../../routes";
import { FirebaseClient } from "../../firebase";
import { updateCheckout } from "../helpers";

export type GoToPendingPayment = (input: {
  business: string;
  checkout: Checkout;
  firebase: FirebaseClient;
  formId: string;
  offerId: string;
}) => Promise<void>;

export const goToPendingPayment: GoToPendingPayment = async ({ checkout, firebase, ...query }) => {
  await updateCheckout({
    data: { ...checkout, status: CheckoutStatus.PendingPayment },
    documentId: query.formId,
    firebase
  });

  Router.pushRoute(
    MapRoutes.CHECKOUT_PENDING_PAYMENT,
    { ...query, formStatus: CheckoutStatus.PendingPayment },
    { shallow: true }
  );
};
